import { DirectUpload } from "@rails/activestorage"
import { Controller } from "stimulus";
import { EMAIL_REGEX, PHONE_REGEX } from './constants';
import { validateForm } from './../validators/formValidation'
export default class extends Controller {
  initialize() {
    this.recordingTimer = null;
  }
  static targets = ["startBtn", "stopBtn", "controls", "liveVideo", "playBtn", "playIcon", "pauseIcon", "titleInput", "titleError", 
    "playText", "rerecordBtn", "recordIcon", "recordCountdown", "recordText", "timerDisplay", "videoTip", "countdown", "captions"];

  async connect() {
    this.chunks = [];
    this.recordedBlob = null;
    this.stream = null;
    this.videoURL = null;
    this.playing = false;
    this.recordingTime = 90;
    this.liveVideoTarget.addEventListener("ended", this.resetPlayButton.bind(this));
    this.recordingStartedAt = null;

    console.log("SpeechRecognition:", window.SpeechRecognition || window.webkitSpeechRecognition);

    this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.lang = "en-US";
    this.recognition.maxAlternatives = 1;

    this.captions = [];
    this.startTime = null;
    this.processedCaptions = "";
    this.recognition.onstart = () => {
      this.startTime = Date.now();
    };

    this.recognition.onresult = (event) => {
      console.log("Speech recognition result event fired!", event);
      const lastResult = event.results[event.resultIndex];

      if (lastResult.isFinal) {
        const transcript = lastResult[0].transcript;
    
        this.captions.push(transcript);
      }

      console.log("Captured captions:", this.captions);
    };

    this.recognition.onend = () => console.warn("Speech recognition ended unexpectedly.");
    this.recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
    
      if (event.error === "no-speech") {
        console.warn("No speech detected. Restarting...");
        this.recognition.start();
      }
    };
    
    this.recognition.onspeechend = () => {
      console.warn("Speech ended. Restarting...");
      this.recognition.start();
    };
  }

  async startRecording() {
    this.recordedBlob = null;
    this.liveVideoTarget.muted = true;
    this.videoTipTarget.classList.add("hidden");
    this.playBtnTarget.classList.add("hidden"); 
    this.rerecordBtnTarget.classList.add("hidden");
    this.recordTextTarget.classList.add("hidden");
    this.countdownTarget.classList.remove("is-hidden");
    this.countdownTarget.classList.add("margin-top-large");
    this.recordIconTarget.classList.add("hidden");
    this.recordCountdownTarget.classList.remove("is-hidden");

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
      this.liveVideoTarget.srcObject = this.stream;
      await this.showCountdown();
      this.startBtnTarget.classList.add("hidden"); 
      this.timerDisplayTarget.classList.remove("hidden");
      this.stopBtnTarget.classList.remove("hidden"); 
      this.controlsTarget.classList.remove("hidden"); 
      this.captions = [];
      this.startTime = Date.now();
      this.startTimestamp = Date.now();
      this.recordingStartedAt = performance.now()

      this.recognition.start();

      this.liveVideoTarget.addEventListener("loadedmetadata", () => {
        // this.liveVideoTarget.play(); // plays the video right after recording is done
      });

      this.mediaRecorder = new MediaRecorder(this.stream);
      this.mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          this.chunks.push(e.data);
        }
      };
      this.mediaRecorder.start();
      this.startTimer();

      this.startBtnTarget.disabled = true;
      this.stopBtnTarget.disabled = false;

      this.recordingTimer = setTimeout(() => {
        this.stopRecording();
      }, 90000);
    } catch (error) {
      console.error("Error accessing media devices:", error);
    }
  }

  formatTime(seconds) {
    const date = new Date(null);
    date.setSeconds(seconds);
    return date.toISOString().substr(11, 12).replace('.', ',');
  }
  
  showCountdown() {
    return new Promise((resolve) => {
      let count = 3;
      this.recordCountdownTarget.innerText = count;

      const interval = setInterval(() => {
        count--;
        if (count === 0) {
          this.recordCountdownTarget.innerText = "Start!";
          setTimeout(() => {
            this.recordCountdownTarget.innerText = "";
            this.recordCountdownTarget.classList.add("is-hidden");
            clearInterval(interval);
            resolve();
          }, 500);
        } else {
          this.recordCountdownTarget.innerText = count;
        }
      }, 1000);
    });
  }

  startTimer() {
    let timeLeft = this.recordingTime;
    this.timerDisplayTarget.textContent = `Time Left: ${timeLeft}s`;

    this.timerInterval = setInterval(() => {
      timeLeft--;
      this.timerDisplayTarget.textContent = `Time Left: ${timeLeft}s`;
      
      if (timeLeft <= 10) {
        this.timerDisplayTarget.style.color = 'red';
      }
      if (timeLeft <= 0) {
        clearInterval(this.timerInterval);
        this.timerDisplayTarget.style.color = 'white';
        this.stopRecording();
      }
    }, 1000);
  }

  async saveTestimonial(recordedBlob, reviewId) {
    if (!recordedBlob) {
      console.error("No recorded video to submit!");
      return;
    }

    const file = new File([recordedBlob], "recorded_video.webm", { type: "video/webm" });

    const formData = new FormData();
    formData.append('review_recording[video]', file);
    formData.append('review_recording[review_id]', reviewId);

    try {
      await fetch('/review_recordings', {
        method: 'POST',
        headers: { 'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content },
        body: formData,
      });
    } catch (error) {
      console.error("Error submitting video:", error);
    }
  }

  formatTime(seconds) {
    let date = new Date(seconds * 1000);
    return date.toISOString().substr(11, 8) + ".000"; // Ensure correct WebVTT format
  }
  
  async saveCaptions() {

    let output = this.generateCaptionsVTT(this.captions,
       7,  2.5);

       console.log('output.....', output);
       
    document.getElementById("captions-input").value = output;
  }

  calculateRecordingDuration() {
    if (!this.recordingStartedAt) return 0;
    
    const durationInMs = performance.now() - this.recordingStartedAt;
    const durationInSeconds = Math.max(0, durationInMs / 1000);
    
    return Math.round(durationInSeconds * 10) / 10; // Round to 1 decimal
  }

  async stopRecording() {
    return new Promise((resolve) => {
      const durationInSeconds = this.calculateRecordingDuration();
      sessionStorage.setItem("recordedVideoDuration", this.formatDuration(durationInSeconds));
      this.liveVideoTarget.muted = false;
      this.stopBtnTarget.classList.add("hidden");
      this.timerDisplayTarget.classList.add("hidden");
      this.videoTipTarget.classList.add("hidden");
      this.playBtnTarget.classList.remove("hidden"); 
      this.rerecordBtnTarget.classList.remove("hidden"); 
      if (this.recognition) {
        this.recognition.stop();
      }
      setTimeout(() => this.saveCaptions(), 500);
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
      this.mediaRecorder.stop();
        this.mediaRecorder.addEventListener("stop", async () => {
          this.stream.getTracks().forEach(track => track.stop());
          this.clearTimer();

          if (this.chunks.length > 0) {
            this.recordedBlob = new Blob(this.chunks, { type: "video/mp4" });
            this.videoURL = URL.createObjectURL(this.recordedBlob);
            sessionStorage.setItem("recordedVideo", this.videoURL);

            this.liveVideoTarget.srcObject = null;
            this.liveVideoTarget.src = this.videoURL;
            this.liveVideoTarget.pause();
            this.liveVideoTarget.currentTime = 0;

            this.chunks = [];

          }
          this.startBtnTarget.disabled = false;
          this.stopBtnTarget.disabled = true;
          clearTimeout(this.recordingTimer);
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  clearTimer() {
    clearInterval(this.timerInterval);
    this.timerDisplayTarget.textContent = "";
  }

  async playPauseVideo() {
    if (this.playing) {
      this.liveVideoTarget.pause();
      this.updateButtonState("play");
    } else {
      this.liveVideoTarget.play();
      this.updateButtonState("pause");
    }

    this.playing = !this.playing;
  }

  togglePlayPause() {
    if (this.playing) {
      this.liveVideoTarget.pause();
      this.updateButtonState("play");
    } else {
      this.liveVideoTarget.play();
      this.updateButtonState("pause");
    }

    this.playing = !this.playing;
  }

  resetPlayButton() {
    this.updateButtonState("play");
    this.playing = false;
  }

  updateButtonState(state) {
    if (state === "play") {
      this.playIconTarget.classList.remove("is-hidden");
      this.pauseIconTarget.classList.add("is-hidden");
      this.playTextTarget.textContent = "Play";
    } else {
      this.playIconTarget.classList.add("is-hidden");
      this.pauseIconTarget.classList.remove("is-hidden");
      this.playTextTarget.textContent = "Pause";
    }
  }


  async restartRecording() {
    const userConfirmed = confirm("Are you sure you want to re-record?\nYour current recording will be lost.");
    if (userConfirmed) {
      if (this.recordedBlob) {
        this.recordedBlob = null;
      }
      this.clearRecordingData();
      this.liveVideoTarget.muted = true;
      this.controlsTarget.classList.add("hidden");
      this.startBtnTarget.classList.remove("hidden");
      document.querySelector('.record-container').classList.add('margin-top-xx-large');
      this.recordIconTarget.classList.remove("hidden");
      this.videoTipTarget.classList.remove("hidden");
      this.recordTextTarget.classList.remove("hidden");
      this.liveVideoTarget.src='';
      this.handleRerecord();
    }
  }

  clearRecordingData() {
    sessionStorage.removeItem("recordedVideo");
    sessionStorage.removeItem("recordedVideoDuration");
    this.recordingStartedAt = null;
  }

  formatDuration(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins} min ${secs.toString()} secs`;
  }

  validate_phone() {
    if (!document.getElementById('review_phone_checkbox')) {
      return true;
    }

    const areaCodes = Array.from(document.getElementById('candidate_area_code_select').options)
      .map(option => option.value.replace('+', '').trim())
      .join('|');

    const PHONE_REGEX = new RegExp(`^\\+(${areaCodes})\\s?\\(?\\d{3}\\)?[-\\.\\s]?\\d{3}[-\\.\\s]?\\d{4}$`);
    const phoneCheckbox = document.getElementById('review_phone_checkbox').checked;
    const phoneWrapper  = document.getElementById('user-review-phone-area-code');
    const phoneInput =  document.getElementById('review_candidate_phone');
    const selectedAreaCode = document.getElementById('candidate_area_code_select');

    phoneInput.required = phoneCheckbox;
    phoneWrapper.style.display = phoneCheckbox ? 'block' : 'none';
    phoneInput.value = phoneCheckbox ? phoneInput.value : '';

    const fullPhoneNumber = `${selectedAreaCode.value} ${phoneInput.value.trim()}`;
    return !(fullPhoneNumber !== '' && !PHONE_REGEX.test(fullPhoneNumber));
  }

  validate_email_presence() {
    if (!document.getElementById('review_email_checkbox')) {
      return true;
    }
    const emailCheckbox = document.getElementById('review_email_checkbox').checked;
    const emailInput = document.getElementById('review_candidate_email');

    emailInput.required = emailCheckbox;
    emailInput.style.display = emailCheckbox ? 'block' : 'none';
    emailInput.value = emailCheckbox ? emailInput.value : '';

    const emailValue = emailInput.value.trim();
    if (emailValue !== '' && !EMAIL_REGEX.test(emailValue)) {
      return false;
    }

    return true;
  }

  validate_referral_email_phone(email_phone_value) {
    return EMAIL_REGEX.test(email_phone_value) || PHONE_REGEX.test(email_phone_value);
  }

  validateDuplicates() {
    const referralRows = document.querySelectorAll('.candidate-referral');
    const emails = new Set();
    let hasDuplicates = false;
  
    referralRows.forEach((row) => {
      const emailInput = row.querySelector(`[name="candidate_email"]`);
      const email = emailInput?.value?.trim().toLowerCase();
  
      if (email) {
        if (emails.has(email)) {
          hasDuplicates = true;
        } else {
          emails.add(email);
        }
      }
    });
  
    if (hasDuplicates) {
      const errorContainer = document.getElementById('fixed-notice-container');
      this.displayError($(errorContainer), 'Please remove the duplicate referral emails before submitting.');
      return false;
    }
  
    return true;
  }

  validation(index) {
    let count, name, email, job_title;
    count = parseInt(index[index.length -1]);
    name = document.getElementById(`candidate_name_` + `${count}`);
    email = document.getElementById(`candidate_email_` + `${count}`);
    job_title = document.getElementById(`candidate_job_title_` + `${count}`);
    const inputsNotEmpty = (name.value.trim() + email.value.trim() + job_title.value.trim()).length > 0;
    name.required = email.required = job_title.required = inputsNotEmpty;
  }

  async blobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
  }

  displayError(container, message) {
    container.html(message);
    this.fix_container_function(container);
  }

  async check_email_phone_validity(event) {
    event.preventDefault();
    const form = this.element.closest('form');
    if (!this.validateDuplicates()) {
      return;
    }
    if (!validateForm(form)) return;

    const fixedNoticeContainer = $('#fixed-notice-container');
    const emailBox = document.getElementById('review_email_checkbox');
    const phoneBox = document.getElementById('review_phone_checkbox');
    const emailCheckbox = document.getElementById('review_email_checkbox')?.checked;
    const phoneCheckbox = document.getElementById('review_phone_checkbox')?.checked;
    const titleInput = document.getElementById("review_review_recording_title");
    const videoSection = document.getElementById("video-section");
    const feedbackSection = document.getElementById("feedback-section");
    const savedBlobURL = sessionStorage.getItem("recordedVideo");
    const email_phone_fields = document.getElementsByName('candidate_email');
    if(!savedBlobURL) this.recordedBlob = null;
    const isPhoneValid = this.validate_phone();
    const isEmailValid = this.validate_email_presence();
    if (emailBox && phoneBox) {
      if (!emailCheckbox && !phoneCheckbox) return this.displayError(fixedNoticeContainer, 'Please select either Email or Phone!');
      if (emailCheckbox && !isEmailValid) return this.displayError(fixedNoticeContainer, 'Enter a valid email address!');
      if (phoneCheckbox && !isPhoneValid) return this.displayError(fixedNoticeContainer, 'Enter a valid phone number!');
      if (emailCheckbox && phoneCheckbox && !isEmailValid && !isPhoneValid) return this.displayError(fixedNoticeContainer, 'Enter a valid email address and phone number!');
    }
    
    const isVideoValid = await this.handleVideoValidation(videoSection, titleInput, savedBlobURL, fixedNoticeContainer);
    if (!isVideoValid) return;
    
    const isFeedbackValid = await this.handleFeedbackValidation(feedbackSection, titleInput, savedBlobURL, fixedNoticeContainer);
    if (!isFeedbackValid) return;
    

    email_phone_fields.forEach(element => {
      const candidate_name = document.getElementById('candidate_name_0').value;
      if (candidate_name) {
        if (!this.validate_referral_email_phone(element.value)) {
          if (element.value.trim() === '') {
            fixedNoticeContainer.html(`It is not a valid email address or phone number!`);
          }
          else {
            fixedNoticeContainer.html(`${element.value} is not a valid email address or phone number!`);
          }

          this.fix_container_function(fixedNoticeContainer);
          element.value = null;
          this.validation(element.id.split('_'));
          return;
        }
      }
    });

    if (this.recordedBlob) {
      const form = event.target.closest('form');
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "review_recording[video]";
      const file = new File([this.recordedBlob], "recorded-video.webm", { type: "video/webm" });
      this.showLoading();
      const blob = await this.directUploadAsync(file);
      input.value = blob.signed_id
      form.appendChild(input);
      this.hideLoading();

      const inputTitle = document.createElement("input");
      inputTitle.type = "hidden";
      inputTitle.name = "review_recording[title]";
      inputTitle.value = titleInput.value.trim();
      form.appendChild(inputTitle);
    }
    form.submit();
  }

  directUploadAsync(file) {
    return new Promise((resolve, reject) => {
      const upload = new DirectUpload(file, "/rails/active_storage/direct_uploads");
  
      upload.create((error, blob) => {
        if (error) {
          reject(error);
        } else {
          resolve(blob);
        }
      });
    });
  }

  showLoading() {
    document.querySelector('.loading-overlay')?.classList.remove('hidden');
    document.querySelectorAll('input, button, select').forEach(el => el.setAttribute('disabled', 'true'));
  }

  hideLoading() {
    document.querySelector('.loading-overlay')?.classList.add('hidden');
    document.querySelectorAll('input, button, select').forEach(el => el.removeAttribute('disabled'));
  }

  async handleFeedbackValidation(feedbackSection, titleInput, savedBlobURL, fixedNoticeContainer) {
    if (!feedbackSection ||feedbackSection?.classList.contains("hidden")) return true;
    return await this.handleTitleVideoValidation(titleInput, savedBlobURL, fixedNoticeContainer);
  }

  async handleVideoValidation(videoSection, titleInput, savedBlobURL, fixedNoticeContainer) {
    if (!videoSection || videoSection?.classList.contains("hidden")) return true;
    return await this.handleTitleVideoValidation(titleInput, savedBlobURL, fixedNoticeContainer);
  }

  async handleTitleVideoValidation(titleInput, savedBlobURL, fixedNoticeContainer) {
    if (savedBlobURL && !this.recordedBlob) await this.fetchRecordedBlob(savedBlobURL);
    if (this.recordedBlob && (!titleInput || titleInput.value.trim() === "")) {
      this.displayError(fixedNoticeContainer, 'Please enter a title for your review recording!');
      if (titleInput) {
        titleInput.style.border = "2px solid red";
      }
      return false;
    }
    if (titleInput && titleInput.value.trim() && !this.recordedBlob) {
      this.displayError(fixedNoticeContainer, 'Please record a video before submitting!');
      return false;
    }
    return true
  }

  async fetchRecordedBlob(savedBlobURL) {
    try {
      const response = await fetch(savedBlobURL);
      if (!response.ok) throw new Error(`Failed to fetch video. Status: ${response.status}`);
      this.recordedBlob = await response.blob();
    } catch (error) {
      console.error("Error fetching recorded video:", error);
      this.recordedBlob = null;
    }
  }

  fix_container_function(fixedNoticeContainer) {
    fixedNoticeContainer.removeClass('hidden fade-out');
    setTimeout(() => {
      fixedNoticeContainer.addClass('fade-out');
      setTimeout(() => {
        fixedNoticeContainer.addClass('hidden');
      }, 0);
    }, 5000);
  }
  generateCaptionsVTT(text, wordsPerChunk = 7, secondsPerChunk = 2.5) {
    let words;
    if (text instanceof Array) {
      words = text.join().split(/\s+/);
    } else {
      words = text.split(/\s+/);
    }
    const chunks = [];
    
    for (let i = 0; i < words.length; i += wordsPerChunk) {
      const chunkWords = words.slice(i, i + wordsPerChunk);
      const startTime = i / wordsPerChunk * secondsPerChunk;
      const endTime = startTime + secondsPerChunk;
      
      chunks.push({
        start: this.formatTime(startTime),
        end: this.formatTime(endTime),
        text: chunkWords.join(' ')
      });
    }
    
    return `WEBVTT\n\n` + chunks.map((c, i) => (
      `${i + 1}
      ${c.start} --> ${c.end}
      ${c.text}
      
      `
    )).join('');
  }

  async showRecordedVideoPreview() {
    if (this.mediaRecorder?.state === "recording") {
      await this.stopRecording(); // wait for recording to finish
    }
    const title = this.titleInputTarget.value.trim();
    const videoURL = sessionStorage.getItem("recordedVideo");
    await this.fetchRecordedBlob(videoURL)
    if (!this.recordedBlob) {
      $('#videoModal').foundation('close');
      return;
    }

    if (!title) {
      this.titleErrorTarget.style.display = "block";
      return;
    }
    this.titleErrorTarget.style.display = "none";

    const preview = document.getElementById("recorded-video-preview");
    const video = document.getElementById("preview-video");
    const link = document.getElementById("watch-video-link");
    const durationContainer = document.getElementById("video-duration");
    const recordedVideoDuration = sessionStorage.getItem("recordedVideoDuration");

    const existing = durationContainer.querySelector("span");
    if (existing) existing.remove();

    const p = document.createElement("span");
    p.style.color = "grey";
    p.textContent = `${recordedVideoDuration}`;
    durationContainer.appendChild(p);

    video.src = videoURL;
    link.href = videoURL;

    preview.style.display = "block";

    const buttonContainer = document.getElementById("recordButton");
    buttonContainer.classList.add('hidden');

    const tips = document.getElementById("quick-tips-section");
    if (tips) tips.style.display = "none";

    this.titleErrorTarget.style.display = "none";
    $('#videoModal').foundation('close');
  }

  handleDeleteRecording() {
    this.clearRecordingData();
    this.handleRerecord();

    const liveVideo = document.getElementById("live");
    if (liveVideo) {
      liveVideo.muted = true;
      liveVideo.src = "";
      liveVideo.removeAttribute("srcObject");
    }

    const controls = document.querySelector("[data-target='video-recorder.controls']");
    if (controls) controls.classList.add("hidden");

    const startBtn = document.querySelector("[data-target='video-recorder.startBtn']");
    if (startBtn) startBtn.classList.remove("hidden");

    const recordContainer = document.querySelector(".record-container");
    if (recordContainer) recordContainer.classList.add("margin-top-xx-large");

    const recordIcon = document.querySelector("[data-target='video-recorder.recordIcon']");
    const videoTip = document.querySelector("[data-target='video-recorder.videoTip']");
    const recordText = document.querySelector("[data-target='video-recorder.recordText']");

    if (recordIcon) recordIcon.classList.remove("hidden");
    if (videoTip) videoTip.classList.remove("hidden");
    if (recordText) recordText.classList.remove("hidden");
  }

  handleRerecord() {
    document.getElementById("recorded-video-preview").style.display = "none";

    document.getElementById("recordButton")?.classList.remove("hidden");
    
    const tips = document.getElementById("quick-tips-section");
    if (tips) tips.style.display = "block";
  }
}